{
  "img-alt": "Полноэкранное изображение",
  "close": "Закрыть"
}
